import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/common.service';

declare const JSEncrypt: any;
@Injectable({
  providedIn: 'root',
})
export class UserDetailsService {
  authDetails: any;

  get token(): string {
    return sessionStorage.getItem('access_token') ?? '';
  }

  get userDetails(): UserDetails {
    return JSON.parse(sessionStorage.getItem('userDetails') ?? '{}');
  }

  constructor(private _commonService:CommonService) {}

  get isLoggedIn(): boolean {
    return !!this.token;
  }

  public encryptPassword(password: string): string {
    return this._commonService.doEncrypt(password);
  }

  public setUserDetails(userDetails: UserDetails) {
    console.log(userDetails);
    sessionStorage.setItem('token', userDetails.access_Token);
    sessionStorage.setItem('userDetails', JSON.stringify(userDetails));
  }
}

export interface UserDetails {
  inventoryNumber: string;
  twoFactor: TwoFactor;
  access_Token: string;
  expires_in: string;
  userId: string;
}

export interface TwoFactor {
  mobile: string;
  email: string;
}
